import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// ---- Admin auth (browser-local, used by /admin/leads only) ----
const ADMIN_TOKEN_KEY = "renvia.adminToken";
export function getAdminToken() {
  if (typeof window === "undefined") return "";
  return window.localStorage.getItem(ADMIN_TOKEN_KEY) || "";
}
export function setAdminToken(t) {
  if (typeof window === "undefined") return;
  if (t) window.localStorage.setItem(ADMIN_TOKEN_KEY, t);
  else window.localStorage.removeItem(ADMIN_TOKEN_KEY);
}
function adminParams() {
  return { token: getAdminToken() };
}

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function listLeads() {
  const { data } = await api.get("/leads", { params: adminParams() });
  return data;
}

export async function leadStats() {
  const { data } = await api.get("/leads/stats", { params: adminParams() });
  return data;
}

export async function patchLeadMilestone(leadId, milestone) {
  const { data } = await api.patch(
    `/leads/${leadId}/milestone`,
    { milestone },
    { params: adminParams() }
  );
  return data;
}

export async function submitCareer(payload) {
  const { data } = await api.post("/careers", payload);
  return data;
}

export async function fetchVideos() {
  const { data } = await api.get("/content/videos");
  return data;
}

export async function fetchClinicalApps() {
  const { data } = await api.get("/content/clinical-applications");
  return data;
}

export async function fetchStats() {
  const { data } = await api.get("/content/stats");
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}
